export enum PartNoteType {
  DEFAULT = 'default',
}
